import { LegalPage, Section } from "@/components/LegalPage";
import { Link } from "react-router-dom";

export default function Refunds() {
  return (
    <LegalPage title="Refund Policy" testId="refunds-title">
      <Section title="1. General Policy">
        <p>BeatCredsi™ subscriptions (Founding Producer, Roadmap, and their annual variants) are recurring digital services. Because access is granted immediately upon payment, <strong>all sales are generally final.</strong> Exceptions are described below.</p>
      </Section>

      <Section title="2. 7-Day Refund Window (Annual Plans Only)">
        <p>If you purchase an <strong>annual plan</strong> (Founding Annual $140/yr or Roadmap Annual $199/yr) and request a refund within <strong>seven (7) calendar days</strong> of purchase, you may receive a full refund, provided that:</p>
        <ul>
          <li>You have not completed any certification exams</li>
          <li>You have not earned a Founding Producer seat</li>
          <li>You have not downloaded substantial proprietary content</li>
        </ul>
        <p>To request, email <a href="mailto:contact@onlymartian.com">contact@onlymartian.com</a> with the subject "Refund Request" and your account email.</p>
      </Section>

      <Section title="3. Monthly Plans">
        <p>Monthly plans ($14/mo Founding, $20/mo Roadmap) are <strong>non-refundable</strong>. You may cancel auto-renewal at any time from your <Link to="/account" className="text-amber-500">Account</Link> page; access continues until the end of the current billing period.</p>
      </Section>

      <Section title="4. Founding Producer Seats">
        <p>Founding Producer status is limited to the first 100 paying members and is awarded irrevocably upon successful payment. A refunded Founding payment will <strong>forfeit your Founding seat permanently</strong>, and the seat will return to the pool for the next eligible producer.</p>
      </Section>

      <Section title="5. Failed or Unauthorized Charges">
        <p>If you believe a charge is incorrect or unauthorized:</p>
        <ul>
          <li>Email <a href="mailto:contact@onlymartian.com">contact@onlymartian.com</a> first — most issues resolve within 48 hours.</li>
          <li>Do not chargeback before contacting us. Unwarranted chargebacks may result in immediate account termination and may be disputed with Stripe.</li>
        </ul>
      </Section>

      <Section title="6. Service Outages">
        <p>If the Platform is unavailable for an extended period due to our error, we may issue a pro-rata credit at our discretion.</p>
      </Section>

      <Section title="7. Processing Time">
        <p>Approved refunds are issued to your original payment method via Stripe within 5–10 business days. Bank posting times may vary.</p>
      </Section>

      <Section title="8. Cancellation vs. Refund">
        <p>Canceling your subscription stops future renewals but does not refund the current period. To request a refund, you must explicitly email us — canceling alone does not trigger a refund.</p>
      </Section>

      <Section title="9. Contact">
        <p>Email <a href="mailto:contact@onlymartian.com">contact@onlymartian.com</a> with the subject "Refund Request."</p>
      </Section>
    </LegalPage>
  );
}
